import React from "react";

const Footer = () => {
  return <div className="h-14 border-t-[1px] "></div>;
};

export default Footer;
